
export { updateProductPrice } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-grandiaziende-deploy-prod/libs/consumer/ibuyfixed/src/lib/ShoppingCart/shoppingCart.utils.ts"